<intello-dialog-header class="dialog-header" [title]="'Table Settings'" (emitCloseClick)="dialogRef.close(null)">
</intello-dialog-header>

<intello-dialog-content>
  <p class="change-notification">
    {{'General.You can change the column order via drag and drop.' | translate }}
  </p>
  <div class="conf-table-dialog-container">
    <div  class="conf-table-dialog-menu">
      <div >
        <p>
          <a (click)="setToDefault()" class="default">{{'General.Set to default' | translate}}</a>
        </p>
      </div>
      <div >
        <p class="show-hide">
         {{'General.Hide / Show' | translate }}
        </p>
      </div>
    </div>
    <div class="conf-table-dialog-columns">

      <div cdkDropList class="columns" (cdkDropListDropped)="drop($event)">
        <div class="column" *ngFor="let column of columns" cdkDrag>
          <div >
            <div  class="column__key">
              {{ column.value }}
            </div>
            <div  class="column_toggle" class="toggle-container">
              <mat-slide-toggle class="toggle" color="primary" [checked]="column.visibility"
                (change)="changeVisibility(column)">
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</intello-dialog-content>

<intello-dialog-footer>
  <div >
    <div >
      <button mat-raised-button (click)="closeDialog(null)">{{'General.Discard' | translate }}</button>
    </div>
    <div >
      <button mat-raised-button (click)="closeDialog(columns)" color="primary">{{'General.Save' | translate }}</button>
    </div>
  </div>
</intello-dialog-footer>